import { render, staticRenderFns } from "./CreduLista.vue?vue&type=template&id=1772a36a&scoped=true"
import script from "./CreduLista.vue?vue&type=script&lang=js"
export * from "./CreduLista.vue?vue&type=script&lang=js"
import style0 from "./CreduLista.vue?vue&type=style&index=0&id=1772a36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772a36a",
  null
  
)

export default component.exports